import Api from 'src/util/api';
import { Result, PageDo, ResultPageDo, Integer } from 'src/types/base';
import { EXDEV } from 'constants';

/**
 * @Author:
 * @Description:
 * @DateTime: Created in 9:44 2018/11/26
 */

export declare namespace StationDetailDOI {
    export interface QueryTrendencyMonitoringParamsI extends PageDo {
        start_time: number;
        end_time: number;
        mn: string;
        cn: string;
    }
    export interface StationWarnSettingsI {
        alarm_ceiling: Integer;
        alarm_floor: Integer;
        check_standard: Integer;
        check_span: Integer;
        check_zero: Integer;
        component_id: number;
        component_name: string;
        department: number;
        device_id: number;
        device_name: string;
        id: number;
        key: string;
        device_info:string;
        manufacturer_name:string;
        type:string;
        device_code:string;
        range_s:string;
    }
    export interface SaveStationSettingsI{
        device_id: number
        device_name: string
        alarm_threshold_value: {component_id: Integer, alarm_ceiling: Integer, alarm_floor: Integer}[]
        alarm_user_info: {user_id: number, user_name: string, mobile: string}[]
        devops_personnel: string
        devops_mobile	: string
    }
}
export default class StationDetailApi {
    /**
     * @param params
     */
    static async searchTrendencyMonitoring(
        params: StationDetailDOI.QueryTrendencyMonitoringParamsI,
    ): Promise<ResultPageDo<any[], { key: string; name: string,unit:string }[]>> {
        return Api.post('/monitor/trend_monitoring/site', params);
    }
    static async searchDataDetail(
        mn: string,
        product_id: number,
    ): Promise<ResultPageDo<any[], { cn_type: string; data: string; data_time: string; divisor: string }[]>> {
        return Api.post('/monitor/point/cn/last/data/get', { mn, product_id });
    }
    /**
     * 查询关键参数
     * @param mn c
     * @param id
     */
    static async searchKeyParams(mn: string, id: number): Promise<ResultPageDo<any[], { component_name: string; key: string }[]>> {
        return Api.post('/countercharge/key_parameter/gain', { mn, id });
    }
    static async searchSysParams(mn: string, id: number): Promise<Result<{ name: string; value: string }[]>> {
        return Api.post('/countercharge/key_parameter/system', { mn, id });
    }


    /**
     * 查询关键参数
     * @param mn c
     * @param id
     */
    static async searchKeyStatus(mn: string, id: number): Promise<ResultPageDo<any[], { component_name: string; key: string }[]>> {
        return Api.post('/countercharge/working_condition/instrument', { mn, id });
    }
    static async searchSysStatus(mn: string): Promise<Result<{RunMode: number}>> {
        return Api.post('/countercharge/running_mode/system', { mn });
    }


    static async updateStaion(params): Promise<Result<any>> {
        return Api.post('/monitor/point/device/component/alarm_ceiling/update', params);
    }

    static async searchStationWarnSettings(deviceId: number): Promise<Result<StationDetailDOI.StationWarnSettingsI[]>> {
        return Api.post('/monitor/point/device/component/data', { device_id: deviceId, page_index: 1, page_size: 100000000 });
    }

    static async searchAlarmPerson(deviceId: number): Promise<Result<{user_id:number,user_name: string}[]>> {
        return Api.post('/monitor/personnel/alarm/inform/query', { device_id: deviceId });
    }
    
    /**
     * 查询报警管理刷新周期
     * @param deviceId 
     */
    static async searchRefreshCycle(deviceId: number): Promise<Result<{refresh_cycle:number}>> {
        return Api.post('/monitor/get/alarm/refresh_cycle', { device_id: deviceId });
    }

    static async searchNewOperationalTime(deviceId: number): Promise<Result<any>>{
        return Api.post('/ops/query/recently/operational_time', {device_id: deviceId})
    }
    static async changeAlarmNotice(id: number, is_warning_notice: number): Promise<Result<any>> {
        return Api.post('/monitor/warning_notice/whether_participate', { id, is_warning_notice });
    }
    static async saveStationSettings(params: StationDetailDOI.SaveStationSettingsI): Promise<Result<any>> {
        return Api.post('/monitor/data/site/seeting', params);
    }
    static async saveStationSettingsAlarms(params: StationDetailDOI.SaveStationSettingsI): Promise<Result<any>> {
        return Api.post('/monitor/data/site/seetingalarm', params);
    }
    static async getDvr(params: {device_id: number, page_index?: number, page_size?: number}): Promise<ResultPageDo<{name: string,id: number,}[]>>  {
        return Api.post('/srs_live/dvr/data', {
            page_index:1,
            page_size: 100000000,
            ...params,
        });
    }
}
